// extracted by mini-css-extract-plugin
module.exports = {"link":"heading-link-module--link--3Z5RE"};